export default {
  unvalid_data: 'Please enter your payment card information.',
  declined: 'Your payment was declined. Please try again or use a different payment method.',
  declined_link: 'Your payment was declined. {link}',
  link: 'Tap here to select a different payment method.',
  invalid_email: 'This email address looks wrong. Please enter a valid email address.'
}
